import {useQuery} from "@tanstack/react-query";
import {readPresentInvDetailHistory} from "../../../../../api/inventory/InvApi";
import {InvDetailHistorySearchParamType} from "../interface";
import {invDetailHistoryMapInit} from "../state";

type Props = {
    param: InvDetailHistorySearchParamType;
};

export const useReadPresentInvDetailHistory = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readPresentInvDetailHistory", param],
        queryFn: async () => await readPresentInvDetailHistory(param),
        select: (res) => {
            const result = res?.data.result

            if (!result || !result.inventoryDetailHistoryRes.inventoryDetailEachHistoryResList) {
                return invDetailHistoryMapInit
            } else {
                return result
            }
        },
    });

    return {data};
};
